// Extracted from original/src/App.tsx:26228-26303 (ADR-08 §2.1): the header actions of the "calculator & chat"
// tabs — wallets, dollar, currencies, movements, transfers_cash, financials, store (:26230-26237) — the Smart
// Calculator button (:26243-26269, theme colour background) and the Internal Operator Chat button
// (:26272-26302, unread badge or the green pulse). Cut: `setShowCalculator`, `setShowOperatorChat`,
// `setUnreadChatCount` → callbacks; `themeColor` → prop. The container renders it in the Layout's
// `headerExtra` slot for those tabs (C19 for wallets; the calculator and chat dialogs arrive with D09).
import { Calculator, MessageSquare } from 'lucide-react';
import { useT } from '../i18n-context.js';

export interface CalculatorChatActionsProps {
  readonly themeColor: string;
  readonly unreadChatCount: number;
  readonly onCalculator: () => void;
  readonly onChat: () => void;
}

/** Tabs that show these actions (App.tsx:26230-26237). */
export const CALCULATOR_CHAT_TABS: readonly string[] = ['wallets', 'dollar', 'currencies', 'movements', 'transfers_cash', 'financials', 'store'];

export function CalculatorChatActions(props: CalculatorChatActionsProps) {
  const t = useT();
  return (
    <div className="flex items-center gap-2.5" data-testid="calculator-chat-actions">
      {/* Smart Calculator Button */}
      <button
        type="button"
        id="header_smart_calculator_btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onCalculator();
        }}
        style={{
          backgroundColor: props.themeColor,
        }}
        className="text-white px-4 sm:px-5 py-2 rounded-xl flex items-center gap-2 hover:opacity-90 transition-all shadow-lg shadow-blue-600/20 font-black tracking-tight cursor-pointer active:scale-95"
        title={t('layout.smart_calculator_title')}
      >
        <Calculator
          size={18}
          className="filter drop-shadow-[0_0_5px_rgba(255,255,255,0.5)] shrink-0"
        />
        <span className="text-xs sm:text-sm whitespace-nowrap">
          {t('layout.smart_calculator')}
        </span>
      </button>

      {/* Internal Operator Chat Button */}
      <button
        type="button"
        id="header_operator_chat_btn"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onChat();
        }}
        className="bg-white dark:bg-[#0d1117] border border-gray-200 dark:border-[#30363d] text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-950/40 px-3.5 sm:px-4 py-2 rounded-xl flex items-center gap-2 transition-all shadow-sm font-black tracking-tight cursor-pointer active:scale-95 group relative"
        title={t('layout.operator_chat_title')}
      >
        <MessageSquare
          size={18}
          className="group-hover:scale-110 transition-transform text-indigo-600 dark:text-indigo-400 shrink-0"
        />
        <span className="text-xs sm:text-sm text-gray-800 dark:text-gray-200 whitespace-nowrap">
          {t('layout.operator_chat')}
        </span>
        {props.unreadChatCount > 0 ? (
          <span className="min-w-[18px] h-[18px] bg-rose-500 text-white text-[10px] font-black rounded-full flex items-center justify-center px-1 shadow-md animate-bounce">
            {props.unreadChatCount}
          </span>
        ) : (
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse border-2 border-white dark:border-[#0d1117]" />
        )}
      </button>
    </div>
  );
}
